import { useAdminStore } from '@admin/AppProvider'
import { useTranslate } from '@tolgee/react'
import { ConfirmationDialog, Loader } from '@tom-ui/ui'
import { useAsyncFetch } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { Helmet } from 'react-helmet-async'
import { TenantsContainer } from './containers/TenantsContainer'

const Tenants = observer(() => {
  const { t } = useTranslate()
  const { tenantUIStore, timezonesStore } = useAdminStore()

  const { loading } = useAsyncFetch(async () => {
    const requests = [timezonesStore.load(), tenantUIStore.store.load()]
    await Promise.all(requests)
  }, [tenantUIStore.store, timezonesStore])

  const handleDelete = async () => {
    await tenantUIStore.store.delete(tenantUIStore.toBeRemoveTenantId!)

    tenantUIStore.setToBeRemoveTenantId()
  }

  return (
    <>
      <Helmet>
        <title>{t('tenants', 'Tenants')}</title>
      </Helmet>

      {loading ? <Loader show /> : <TenantsContainer />}

      <ConfirmationDialog
        open={!!tenantUIStore.toBeRemoveTenantId}
        title={t('youAreAboutToRemoveATenant', 'You are about to remove a tenant')}
        message={t('thisActionWillRemoveThisTenant', 'This action will remove this tenant.')}
        primaryActionText={t('remove', 'Remove')}
        closeLabel={t('close', 'Close')}
        onClose={() => tenantUIStore.setToBeRemoveTenantId()}
        onConfirm={handleDelete}
      />
    </>
  )
})

export default Tenants
